import { isEmpty } from "lodash";
import React from "react";
import { formatNumberKandM } from "../../../Utils/helpers";

const RenderOddsSky = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  active,
  betType,
  index,
}) => {
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0 || !isEmpty(odds)) {
        if (Number(odds) > limit?.oddsLimit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  return (
    <React.Fragment>
      {odds_back?.length > 0 ? (
        odds_back?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldBack?.length > 0
              ? res?.rt != oldBack[id]?.rt || res?.bv != oldBack[id]?.bv
              : false;
          return (
            <dd
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              onClick={(e) => {
                if (disabelBack) {
                } else {
                  if (ms == 1) {
                    if (!checkDisabled(res?.rt)) {
                      handelChange(res, "back", item?.RunnerName, item, e);
                    }
                  }
                }
              }}
              id="back_1"
            >
              <div
                className={`back-1 lay-back-block ${chamak ? "spark" : ""} ${
                  active && betType == "back" ? "select" : ""
                }`}
                fullmarketodds="1.57"
              >
                {res?.rt || ""}
                {component !== "bookmaker" && (
                  <span> {res?.bv > 0 ? formatNumberKandM(res?.bv) : ""}</span>
                )}
              </div>
            </dd>
          );
        })
      ) : (
        <dd id="back_1">
          <div className="back-1 lay-back-block" fullmarketodds="1.57"></div>
        </dd>
      )}
      {odds_lay?.length > 0 ? (
        odds_lay?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldLay?.length > 0
              ? res?.rt != oldLay[id]?.rt || res?.bv != oldLay[id]?.bv
              : false;
          return (
            <dd
              onClick={(e) => {
                if (disabelLay) {
                } else {
                  if (ms == 1) {
                    if (!checkDisabled(res?.rt)) {
                      handelChange(res, "lay", item?.RunnerName, item, e);
                    }
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              id="lay_1"
            >
              <div
                className={`lay-1 lay-back-block  ${chamak ? "spark" : ""} ${
                  active && betType == "lay" ? "select" : ""
                }`}
                fullmarketodds="1.58"
              >
                {res?.rt || ""}
                {component !== "bookmaker" && (
                  <span> {res?.bv > 0 ? formatNumberKandM(res?.bv) : ""}</span>
                )}
              </div>
            </dd>
          );
        })
      ) : (
        <dd id="lay_1">
          <div className="lay-1 lay-back-block" fullmarketodds="1.58"></div>
        </dd>
      )}{" "}
      {disableFull && ms == 1 && (
        <dd id="suspend" className="suspend-fancy">
          <p>Suspend</p>
        </dd>
      )}
    </React.Fragment>
  );
};

export default RenderOddsSky;
